export default __webpack_public_path__ + "static/viinitie-banner-xmass-desktop-wide.4c7725b95ab3982c40a3b36ecc8b65fa.jpg";